(function() {
    'use strict';

    angular
        .module('app.controllers.device.activeManualValues', [])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('device.activeManualValues', {
                    abstract: true,
                    parent: 'device',
                    url: '/activeManualValues',
                    template: '<ui-view></ui-view>',
                    breadcrumb: {
                        ignore: true
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('device.activeManualValues.default', {
                    parent: 'device.activeManualValues',
                    url: '/:menuEntryId',
                    defaultParams: {
                        menuEntryId: '00000000-0000-0000-0000-000000000000'
                    },
                    templateUrl: 'views/CustomActions/deviceActiveManualValues.html',
                    controller: 'DeviceActiveManualValuesCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: function() {
                            return 'NAV_DeviceActiveManualValues';
                        }
                    }
                });
        }])
        .controller('DeviceActiveManualValuesCtrl', DeviceActiveManualValuesCtrl);

    /* @ngInject */
    function DeviceActiveManualValuesCtrl(
        __MenuEntry,
        $translate,
        viewMenuBarService,
        API,
        actualDevice,
        __Bundle
    ) {
        var vm = this;

        var favoriteObject = {
            favoriteType: 'MenuEntry',
            favoriteObject: __MenuEntry.$buildRaw({
                "MenuEntryId": 'fc20303f-05c1-47ae-9ba3-3176bcde521b',
                "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                "DeviceId": actualDevice.DeviceId,
                'CustomActionName': 'ActiveManualValues',
                'DisplayName': $translate.instant('NAV_DeviceActiveManualValues'),
                'ImageName': 'handbetrieb'
            })
        };
        viewMenuBarService.setFavorite(favoriteObject);

        this.$onInit = () => {
            const api = new API();

            const bundlesFilter = {
                DeviceId: actualDevice.DeviceId,
                Category: 3 /* DatapointCategory.ManualMode */
            };
            const bundlesByCategoryPromise = api.Menu.GetBundlesByCategory(bundlesFilter).$promise;

            bundlesByCategoryPromise
                .then(function(data) {
                    let handBundles = [];

                    data.forEach(function(bundle) {
                        for (let i = 0; i < bundle.Datapoints.length; i++) {
                            if (bundle.Datapoints[i].Config.Category === bundlesFilter.Category
                                && bundle.Datapoints[i].DatapointValue.Value === 1 /* ManualMode.Hand */) {
                                handBundles.push(bundle);
                                break;
                            }
                        }
                    });

                    vm.bundles = __Bundle.$collection();
                    for (var i = 0; i < handBundles.length; i++) {
                        // Initialize every Bundle (and so Datapoint, Value + config)
                        // And Add to Bundle Collection
                        var a = __Bundle.$buildRaw(handBundles[i]);
                        a.$dispatch('build');
                        vm.bundles.$add(a);
                    }
                });
        };

        // If Bundle has only 1 Datapoint => Show this Datapoint in List
        // If Bundle has more than 1 Datapoint AND does not have ActualOrSetpointValue => Show first Datapoint in List
        // If Bundle has more than 1 Datapoint AND has ActualOrSetpointValue => Show only ActualOrSetpointValues in List
        vm.filterDatapoints = (bundle, index) => {

            return function(dp) {
                if (bundle.Datapoints.length === 1) {
                    dp.$UI.showInList = true;
                }
                else if (bundle.$UI && !bundle.$UI.hasActualOrSetPointValue) {
                    if (index === 1) {
                        dp.$UI.showInList = true;
                    } else {
                        dp.$UI.showInList = false;
                    }
                }
                else {
                    if (dp.DatapointConfig.Category >= 2) {
                        dp.$UI.showInList = false;
                    } else {
                        dp.$UI.showInList = true;
                    }
                }

                return dp.$UI.showInList;
            };
        };

    }
})();
